/* Saéa "Kept by" reviews page — hydrates the curated wall + full list from
   window.SAEA_REVIEWS (assets/saea-reviews.js). All review text is injected via
   textContent (user content — never innerHTML). Every published review is from a verified customer (Etsy imports included), so ✓ always shows.

   Customer photos: reviews carry an optional `pics` array of Judge.me image URLs.
   Baked photos come from the data asset; fresh ones arrive via the live refresh
   below. Only review-images.judgeme.com URLs are ever rendered.

   Live refresh: the baked asset is a snapshot, so on load we also pull the
   Judge.me public widget feed (CORS-allowed for saeadesigns.com) and merge in
   anything newer — reviews AND photos. Purely additive: if the fetch fails the
   page is exactly the baked page. Dedupes by review id, then by author+body
   (Judge.me emits one review per line item, so a 12-item order yields 12
   identical copies — the original bake stripped those and so do we). */
(function () {
  'use strict';
  var root = document.querySelector('.saea-rv');
  var DATA = window.SAEA_REVIEWS;
  if (!root || !DATA) return;
  if (root.getAttribute('data-saea-init')) return; // guard against double-execution
  root.setAttribute('data-saea-init', '1');

  var wallEl = root.querySelector('[data-wall]');
  var listEl = root.querySelector('[data-list]');
  var moreBtn = root.querySelector('[data-more]');
  var showingEl = root.querySelector('[data-showing]');
  var collSel = root.querySelector('[data-collection]');
  var sortSel = root.querySelector('[data-sort]');
  var pillWrap = root.querySelector('.saea-rv__pills');
  var perPage = parseInt(root.getAttribute('data-per-page'), 10) || 12;
  var listLabelEl = root.querySelector('[data-list-label]');
  var defaultListLabel = listLabelEl ? listLabelEl.textContent : '';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var state = { filter: 'all', collection: '', sort: 'recent', shown: perPage };
  var FEAT_IDS = {};
  (DATA.featured || []).forEach(function (r) { if (r && r.id) FEAT_IDS[r.id] = true; });
  var MONTHS =['January','February','March','April','May','June','July','August','September','October','November','December'];

  /* photos live on this host only — anything else is ignored outright */
  var PIC_HOST = 'review-images.judgeme.com';
  /* show the "With photos" pill only once there are enough to fill a row */
  var PHOTO_PILL_MIN = 4;

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }
  function stars(n, cls) {
    var w = el('span', cls || 'saea-rv__stars');
    w.setAttribute('role', 'img');
    w.setAttribute('aria-label', n + ' out of 5 stars');
    for (var i = 1; i <= 5; i++) {
      var s = el('span', 'saea-rv__star' + (i <= n ? ' is-on' : ''));
      s.setAttribute('aria-hidden', 'true');
      w.appendChild(s);
    }
    return w;
  }
  function fmtDate(d) {
    if (!d) return '';
    var p = String(d).split('-');
    if (p.length < 2) return '';
    return (MONTHS[parseInt(p[1], 10) - 1] || '') + ' ' + p[0];
  }
  function titleCase(s) {
    return String(s).toLowerCase().replace(/\b\w/g, function (m) { return m.toUpperCase(); });
  }
  function verifiedBadge() { return el('span', 'saea-rv__verified', 'Verified buyer'); }
  /* "Colorway | SAÉA Name" → "Name — colorway"; "Name | SAÉA" → "Name" */
  function prodLabel(p) {
    var s = String(p || '').trim();
    var i = s.indexOf(' | ');
    if (i < 0) return s.replace(/^SAÉA\s+/, '');
    var left = s.slice(0, i).trim(), right = s.slice(i + 3).replace(/^SAÉA\s*/, '').trim();
    return right ? right + ' — ' + left.toLowerCase() : left;
  }
  /* The piece the review is for. A live product (baked `u`) gets a chip: its photo,
     its name and an arrow, the whole row one link — so it reads as "go see this piece",
     not as a caption. A piece that is no longer live keeps a plain, unlinked line. */
  var PIECE_IMG = {};   // handle -> Promise<url|null>, one request per product
  function pieceImage(handle) {
    if (!PIECE_IMG[handle]) {
      PIECE_IMG[handle] = fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
        .then(function (res) { return res.ok ? res.json() : null; })
        .then(function (j) {
          var src = j && j.featured_image;
          return src ? src + (src.indexOf('?') < 0 ? '?' : '&') + 'width=160' : null;
        })
        .catch(function () { return null; });
    }
    return PIECE_IMG[handle];
  }
  var pieceIO = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (!en.isIntersecting) return;
      pieceIO.unobserve(en.target);
      loadPieceThumb(en.target);
    });
  }, { rootMargin: '300px 0px' }) : null;
  function loadPieceThumb(thumb) {
    pieceImage(thumb.getAttribute('data-handle')).then(function (src) {
      if (!src) return;
      var img = new Image();
      img.alt = ''; img.width = 52; img.height = 52; img.decoding = 'async';
      img.onload = function () { thumb.appendChild(img); thumb.classList.add('is-loaded'); };
      img.src = src;
    });
  }
  function productChip(r, hero) {
    if (!r.p) return null;
    var name = prodLabel(r.p);
    var m = r.u ? String(r.u).match(/\/products\/([^#?/]+)/) : null;
    if (!m) return el('span', 'saea-rv__piece-off', 'on ' + name);
    var a = el('a', 'saea-rv__piece' + (hero ? ' saea-rv__piece--hero' : ''));
    a.href = r.u;
    var thumb = el('span', 'saea-rv__piece-thumb');
    thumb.setAttribute('data-handle', m[1]);
    thumb.setAttribute('aria-hidden', 'true');
    a.appendChild(thumb);
    var txt = el('span', 'saea-rv__piece-text');
    txt.appendChild(el('span', 'saea-rv__piece-eyebrow', 'shop this piece'));
    txt.appendChild(el('span', 'saea-rv__piece-name', name));
    a.appendChild(txt);
    var arrow = el('span', 'saea-rv__piece-arrow', '\u2192');
    arrow.setAttribute('aria-hidden', 'true');
    a.appendChild(arrow);
    if (pieceIO) pieceIO.observe(thumb); else loadPieceThumb(thumb);
    return a;
  }
  function animateIn(node, i) {
    if (reduce) { node.classList.add('is-shown'); return; }
    node.style.animationDelay = Math.min(i * 45, 340) + 'ms';
  }
  function scrollToList() {
    var target = root.querySelector('.saea-rv__all');
    if (!target) return;
    var y = target.getBoundingClientRect().top + window.pageYOffset - 96;
    window.scrollTo({ top: y < 0 ? 0 : y, behavior: reduce ? 'auto' : 'smooth' });
  }
  function updateListLabel() {
    if (!listLabelEl) return;
    var txt = defaultListLabel;
    if (state.collection) txt = '— ' + titleCase(state.collection);
    else if (state.filter === 'photos') txt = '— with photos';
    else if (state.filter === 'stone') txt = '— stone';
    else if (state.filter === 'jewelry') txt = '— jewelry';
    listLabelEl.textContent = txt;
  }

  /* ---- customer photos ---- */
  function safePic(u) {
    if (!u) return '';
    try {
      var url = new URL(u, window.location.href);
      if (url.protocol !== 'https:' || url.hostname !== PIC_HOST) return '';
      return url;
    } catch (e) { return ''; }
  }
  /* Judge.me resizes on the fly via ?width= — ask for exactly what we paint */
  function picAt(u, w) {
    var url = safePic(u);
    if (!url) return '';
    url.searchParams.set('quality', '80');
    url.searchParams.set('width', String(w));
    return url.toString();
  }
  function picsOf(r) {
    return (r && r.pics ? r.pics : []).filter(function (u) { return !!safePic(u); });
  }
  function photoStrip(r, variant) {
    var pics = picsOf(r);
    if (!pics.length) return null;
    var wrap = el('div', 'saea-rv__pics' + (variant ? ' saea-rv__pics--' + variant : ''));
    var thumb = variant === 'feat' ? 640 : 320;
    pics.slice(0, 4).forEach(function (u, i) {
      var btn = el('button', 'saea-rv__pic');
      btn.type = 'button';
      btn.setAttribute('aria-label', 'Open customer photo ' + (i + 1) + ' of ' + pics.length +
        (r.a ? ' from ' + r.a : '') + ' — full size');
      var img = document.createElement('img');
      img.className = 'saea-rv__pic-img';
      img.loading = 'lazy';
      img.decoding = 'async';
      img.alt = 'Customer photo' + (r.p ? ' of ' + r.p : '') + (r.a ? ', by ' + r.a : '');
      img.src = picAt(u, thumb);
      btn.appendChild(img);
      btn.addEventListener('click', function () { openLightbox(pics, i, r); });
      wrap.appendChild(btn);
    });
    if (pics.length > 4) {
      var more = el('span', 'saea-rv__pic-more', '+' + (pics.length - 4));
      wrap.appendChild(more);
    }
    return wrap;
  }

  /* ---- lightbox ---- */
  var lb = null;
  function buildLightbox() {
    if (lb) return lb;
    var o = el('div', 'saea-rv__lb');
    o.setAttribute('role', 'dialog');
    o.setAttribute('aria-modal', 'true');
    o.setAttribute('aria-label', 'Customer photo');
    o.hidden = true;
    var fig = el('figure', 'saea-rv__lb-fig');
    var img = document.createElement('img');
    img.className = 'saea-rv__lb-img';
    img.alt = '';
    var cap = el('figcaption', 'saea-rv__lb-cap');
    fig.appendChild(img);
    fig.appendChild(cap);
    var close = el('button', 'saea-rv__lb-close');
    close.type = 'button';
    close.setAttribute('aria-label', 'Close photo');
    var prev = el('button', 'saea-rv__lb-nav saea-rv__lb-nav--prev');
    prev.type = 'button';
    prev.setAttribute('aria-label', 'Previous photo');
    var next = el('button', 'saea-rv__lb-nav saea-rv__lb-nav--next');
    next.type = 'button';
    next.setAttribute('aria-label', 'Next photo');
    o.appendChild(close); o.appendChild(prev); o.appendChild(fig); o.appendChild(next);
    document.body.appendChild(o);
    lb = { o: o, img: img, cap: cap, close: close, prev: prev, next: next, pics: [], i: 0, opener: null };
    close.addEventListener('click', closeLightbox);
    prev.addEventListener('click', function () { step(-1); });
    next.addEventListener('click', function () { step(1); });
    o.addEventListener('click', function (e) { if (e.target === o || e.target === fig) closeLightbox(); });
    document.addEventListener('keydown', function (e) {
      if (lb.o.hidden) return;
      if (e.key === 'Escape') closeLightbox();
      else if (e.key === 'ArrowLeft') step(-1);
      else if (e.key === 'ArrowRight') step(1);
    });
    return lb;
  }
  function paint() {
    lb.img.src = picAt(lb.pics[lb.i], 1600);
    var multi = lb.pics.length > 1;
    lb.prev.hidden = !multi;
    lb.next.hidden = !multi;
    lb.cap.textContent = (lb.meta && lb.meta.a ? lb.meta.a : 'Anonymous') +
      (lb.meta && lb.meta.p ? ' · ' + lb.meta.p : '') +
      (multi ? ' · ' + (lb.i + 1) + '/' + lb.pics.length : '');
    lb.img.alt = 'Customer photo' + (lb.meta && lb.meta.p ? ' of ' + lb.meta.p : '');
  }
  function step(n) {
    if (!lb.pics.length) return;
    lb.i = (lb.i + n + lb.pics.length) % lb.pics.length;
    paint();
  }
  function openLightbox(pics, i, meta) {
    buildLightbox();
    lb.pics = pics; lb.i = i; lb.meta = meta;
    lb.opener = document.activeElement;
    lb.o.hidden = false;
    document.documentElement.classList.add('saea-rv-lb-open');
    paint();
    lb.close.focus();
  }
  function closeLightbox() {
    if (!lb || lb.o.hidden) return;
    lb.o.hidden = true;
    lb.img.removeAttribute('src');
    document.documentElement.classList.remove('saea-rv-lb-open');
    if (lb.opener && lb.opener.focus) lb.opener.focus();
  }

  /* ---- curated highlight wall ---- */
  function renderWall() {
    var feat = DATA.featured || [];
    wallEl.textContent = '';
    feat.forEach(function (r, i) {
      var cls = 'saea-rv__fcard';
      if (i === 0) cls += ' saea-rv__fcard--hero';
      else if ((r.b || '').length > 240) cls += ' saea-rv__fcard--tall';
      var card = el('div', cls);
      card.appendChild(stars(r.r, 'saea-rv__fstars'));
      card.appendChild(el('blockquote', 'saea-rv__fquote', '“' + r.b + '”'));
      var strip = photoStrip(r, 'feat');
      if (strip) card.appendChild(strip);
      var meta = el('div', 'saea-rv__fmeta');
      meta.appendChild(el('span', 'saea-rv__fname', '— ' + (r.a || 'Anonymous')));
      var tag = el('span', 'saea-rv__ftag');
      if (r.c) tag.appendChild(document.createTextNode(r.c));
      tag.appendChild(verifiedBadge());
      meta.appendChild(tag);
      card.appendChild(meta);
      var fpiece = productChip(r, i === 0);
      if (fpiece) card.appendChild(fpiece);
      wallEl.appendChild(card);
      animateIn(card, i);
    });
  }

  /* ---- full list ---- */
  function pool() {
    var arr = (DATA.reviews || []).filter(function (r) {
      if (FEAT_IDS[r.id]) return false;
      if (state.filter === 'photos') return picsOf(r).length > 0;
      if (state.filter === 'stone' && r.t !== 'STONE') return false;
      if (state.filter === 'jewelry' && r.t !== 'JEWELRY') return false;
      if (state.collection && r.c !== state.collection) return false;
      return true;
    });
    arr.sort(function (a, b) {
      if (state.sort === 'oldest') return a.d < b.d ? -1 : (a.d > b.d ? 1 : 0);
      return a.d > b.d ? -1 : (a.d < b.d ? 1 : 0);
    });
    return arr;
  }
  function listCard(r) {
    var card = el('div', 'saea-rv__card');
    var top = el('div', 'saea-rv__card-top');
    top.appendChild(stars(r.r, 'saea-rv__card-stars'));
    card.appendChild(top);
    card.appendChild(el('p', 'saea-rv__body', r.b));
    var strip = photoStrip(r);
    if (strip) card.appendChild(strip);
    var meta = el('div', 'saea-rv__meta');
    meta.appendChild(el('span', 'saea-rv__name', r.a || 'Anonymous'));
    if (r.c) meta.appendChild(el('span', 'saea-rv__tag', r.c));
    meta.appendChild(verifiedBadge());
    card.appendChild(meta);
    var piece = productChip(r);
    if (piece) card.appendChild(piece);
    return card;
  }
  function renderList(reset) {
    var arr = pool();
    if (reset) listEl.textContent = '';
    if (!arr.length) {
      listEl.textContent = '';
      listEl.appendChild(el('p', 'saea-rv__empty', 'No reviews match this filter yet.'));
      moreBtn.hidden = true;
      showingEl.textContent = '';
      return;
    }
    var start = reset ? 0 : listEl.querySelectorAll('.saea-rv__card').length;
    for (var i = start; i < state.shown && i < arr.length; i++) {
      var node = listCard(arr[i]);
      listEl.appendChild(node);
      animateIn(node, i - start);
    }
    moreBtn.hidden = state.shown >= arr.length;
    showingEl.textContent = 'Showing ' + Math.min(state.shown, arr.length) + ' of ' + arr.length;
  }

  /* ---- collection dropdown: full taxonomy, grouped, matching the write-a-review form ---- */
  (function buildCollections() {
    var cats = DATA.categories || [];
    if (!cats.length) { // fallback: derive from the reviews we have
      var seen = {};
      (DATA.reviews || []).forEach(function (r) { if (r.c) seen[r.c] = true; });
      cats = Object.keys(seen).sort().map(function (c) { return { c: c, t: '' }; });
    }
    var groups = { STONE: [], JEWELRY: [], '': [] };
    cats.forEach(function (cat) { (groups[cat.t] || groups['']).push(cat.c); });
    [['STONE', 'Stone'], ['JEWELRY', 'Jewelry'], ['', '']].forEach(function (g) {
      var list = groups[g[0]];
      if (!list || !list.length) return;
      var parent = collSel;
      if (g[1]) { var og = document.createElement('optgroup'); og.label = g[1]; collSel.appendChild(og); parent = og; }
      list.forEach(function (c) { var o = el('option', null, titleCase(c)); o.value = c; parent.appendChild(o); });
    });
  })();

  /* ---- "With photos" pill — only worth showing once there are a few ---- */
  var photoPill = null;
  function syncPhotoPill() {
    if (!pillWrap) return;
    var n = (DATA.reviews || []).filter(function (r) { return picsOf(r).length > 0; }).length;
    if (n < PHOTO_PILL_MIN) {
      if (photoPill && state.filter !== 'photos') { photoPill.remove(); photoPill = null; }
      return;
    }
    if (photoPill) return;
    photoPill = el('button', 'saea-rv__pill saea-rv__pill--photos', 'With photos');
    photoPill.type = 'button';
    photoPill.setAttribute('data-filter', 'photos');
    photoPill.setAttribute('role', 'tab');
    photoPill.setAttribute('aria-selected', 'false');
    pillWrap.appendChild(photoPill);
    bindPill(photoPill);
  }

  /* ---- events ---- */
  function bindPill(p) {
    p.addEventListener('click', function () {
      var all = Array.prototype.slice.call(root.querySelectorAll('.saea-rv__pill'));
      all.forEach(function (x) { x.classList.remove('is-active'); x.setAttribute('aria-selected', 'false'); });
      p.classList.add('is-active');
      p.setAttribute('aria-selected', 'true');
      state.filter = p.getAttribute('data-filter');
      state.collection = '';
      if (collSel) collSel.value = '';
      state.shown = perPage;
      updateListLabel();
      renderList(true);
      scrollToList();
    });
  }
  Array.prototype.slice.call(root.querySelectorAll('.saea-rv__pill')).forEach(bindPill);
  collSel.addEventListener('change', function () {
    state.collection = collSel.value;
    Array.prototype.slice.call(root.querySelectorAll('.saea-rv__pill')).forEach(function (x) {
      var on = x.getAttribute('data-filter') === 'all';
      x.classList.toggle('is-active', on);
      x.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    state.filter = 'all';
    state.shown = perPage;
    updateListLabel();
    renderList(true);
    scrollToList();
  });
  sortSel.addEventListener('change', function () { state.sort = sortSel.value; state.shown = perPage; renderList(true); scrollToList(); });
  moreBtn.addEventListener('click', function () { state.shown += perPage; renderList(false); });

  state.collection = (collSel && collSel.value) || ''; // honor a browser-restored filter
  updateListLabel();
  renderWall();
  renderList(true);
  syncPhotoPill();

  /* ---- live refresh from the Judge.me public widget feed ----
     The baked asset is a point-in-time snapshot; this keeps the page current
     (new reviews AND new customer photos) without a re-deploy. Additive only —
     any failure leaves the baked page untouched. */
  (function liveRefresh() {
    if (root.getAttribute('data-live') === 'off') return;
    var shop = root.getAttribute('data-jm-shop');
    var token = root.getAttribute('data-jm-token');
    if (!shop || !token) return;
    var MAX_PAGES = 10;
    var HANDLES = DATA.handles || {};
    /* same quality bar the baked asset uses, so live rows look like baked rows */
    var MIN_BODY = 24;
    var GENERIC = { 'anonymous': 1, 'customer': 1, 'etsy customer': 1 };

    function norm(s) { return String(s || '').toLowerCase().replace(/\s+/g, ' ').trim(); }
    function key(a, b) { return norm(a) + '|' + norm(b); }

    var byId = {};
    var byText = {};
    (DATA.featured || []).concat(DATA.reviews || []).forEach(function (r) {
      if (r.id) byId[r.id] = r;
      byText[key(r.a, r.b)] = r;
    });

    function parsePage(html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      return Array.prototype.slice.call(doc.querySelectorAll('.jdgm-rev')).map(function (n) {
        var rating = n.querySelector('.jdgm-rev__rating');
        var ts = n.querySelector('.jdgm-rev__timestamp');
        var author = n.querySelector('.jdgm-rev__author');
        var body = n.querySelector('.jdgm-rev__body');
        var prod = n.querySelector('.jdgm-rev__prod-link');
        var handle = '';
        if (prod) {
          var m = (prod.getAttribute('href') || '').match(/\/products\/([^#?/]+)/);
          if (m) handle = m[1];
        }
        var pics = Array.prototype.slice.call(n.querySelectorAll('.jdgm-rev__pic-link'))
          .map(function (a) { return a.getAttribute('data-mfp-src') || a.getAttribute('href') || ''; })
          .filter(function (u) { return !!safePic(u); });
        return {
          id: n.getAttribute('data-review-id') || '',
          r: parseInt(rating && rating.getAttribute('data-score'), 10) || 5,
          v: n.getAttribute('data-verified-buyer') === 'true',
          d: ((ts && ts.getAttribute('data-content')) || '').slice(0, 10),
          a: (author && author.textContent || '').trim(),
          b: (body && body.textContent || '').trim(),
          p: (prod && prod.textContent || '').trim(),
          h: handle,
          u: handle && handle !== 'judgeme-shop-reviews' ? '/products/' + handle : '',
          pics: pics
        };
      });
    }

    function fetchPage(p) {
      var u = 'https://judge.me/api/v1/widgets/all_reviews_page?shop_domain=' +
        encodeURIComponent(shop) + '&api_token=' + encodeURIComponent(token) +
        '&platform=shopify&page=' + p;
      return fetch(u, { credentials: 'omit' })
        .then(function (res) { return res.ok ? res.json() : null; })
        .then(function (j) { return j && j.all_reviews ? parsePage(j.all_reviews) : []; })
        .catch(function () { return []; });
    }

    /* The feed is newest-first and the bake is only ever behind, so everything
       we're missing sits at the front. Walk pages until one turns up nothing
       new — steady state is 2 requests, and it still catches up in full if the
       baked asset has gone months stale. */
    function walk(page, seenNothingNew) {
      if (page > MAX_PAGES) return Promise.resolve();
      return fetchPage(page).then(function (batch) {
        if (!batch.length) return;
        var fresh = absorb(batch);
        if (!fresh && seenNothingNew) return; // two dry pages in a row — done
        return walk(page + 1, !fresh);
      });
    }

    var addedReviews = 0, addedPics = 0;

    function absorb(live) {
      var before = addedReviews + addedPics;
      live.forEach(function (r) {
        if (!r.b || !r.id) return;
        var existing = byId[r.id] || byText[key(r.a, r.b)];
        if (existing) {
          /* already on the page — but it may have gained photos since the bake */
          if (r.pics.length && !(existing.pics && existing.pics.length)) {
            existing.pics = r.pics;
            addedPics++;
          }
          return;
        }
        /* Judge.me hands back "Anonymous" when name display is off — drop the
           placeholder so the card reads "Anonymous" like every other one. */
        var named = !GENERIC[norm(r.a)] && norm(r.a) !== '';
        if (!named) r.a = null;
        /* a photo is its own proof — it earns a slot even without a display name */
        if (r.b.length < MIN_BODY || !(named || r.pics.length)) return;
        var meta = HANDLES[r.h];
        if (meta) { r.t = meta[0]; r.c = meta[1]; }
        DATA.reviews.push(r);
        byId[r.id] = r;
        byText[key(r.a, r.b)] = r;
        addedReviews++;
      });
      return (addedReviews + addedPics) > before;
    }

    walk(1, false).then(function () {
      if (!addedReviews && !addedPics) return;
      if (addedPics) renderWall(); // a featured quote may have gained its photo
      renderList(true);
      syncPhotoPill();
    });
  })();
})();
